import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

import { DrycutLogo } from './DrycutLogo';
import { Stack } from './Stack';

type Props = PropsWithChildren<{
  className?: string;
  logoClasses?: string;
  src: string;
}>;

export function FullscreenImageLayout({
  src,
  className = '',
  logoClasses = '',
  children,
}: Props): React.ReactElement {
  const finalLogoClasses = twMerge('hidden m-8 lg:block absolute', logoClasses);
  const finalClasses = twMerge('min-h-svh w-full bg-cover bg-center', className);

  return (
    <Stack className={finalClasses} style={{ backgroundImage: `url(${src})` }}>
      <DrycutLogo width={75} className={finalLogoClasses} />

      {children}
    </Stack>
  );
}
